import { render, staticRenderFns } from "./toggleButton.vue?vue&type=template&id=6d6bcd0b&scoped=true&"
import script from "./toggleButton.vue?vue&type=script&lang=js&"
export * from "./toggleButton.vue?vue&type=script&lang=js&"
import style0 from "./toggleButton.vue?vue&type=style&index=0&id=6d6bcd0b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6bcd0b",
  null
  
)

export default component.exports